<template>
	<ContextHeader :placement="placement" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { getPlacement } from '@/store/modules/placements/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import ContextHeader from './ContextHeader.vue';
export default {
	name: 'ContextHeaderDataProvider',
	props: { placementId: { type: Number } },
	components: { ContextHeader },
	computed: {
		...mapGettersShorthand({ getPlacement }),
		placement() {
			return this.getPlacement(this.placementId);
		},
	},
};
</script>

<style lang="scss" scoped></style>
